import React from 'react'
import {Sahel, kasba, alhor, Dawajin} from '../Assets/types'

const TypesFood = () => {
    const types = [
        Sahel, kasba, alhor, Dawajin
    ]

    // Create multiple copies for seamless scrolling
    const repeatedTypes = [...types, ...types, ...types, ...types, ...types, ...types]

    return (
        <div className='w-full bg-[#F4F4F4] md:py-10 py-7 relative overflow-hidden'>
            <div className='relative flex gap-16 overflow-hidden'>
                <div className='flex gap-16 animate-infinite-scroll-smooth'>
                    {/* First set of images */}
                    {repeatedTypes.map((type, index) => (
                        <div 
                            key={`first-${index}`} 
                            className='type w-[100px] h-[100px] flex justify-center items-center '
                        >
                            <img 
                                src={type} 
                                alt="type" 
                                className='w-full h-full object-contain'
                            />
                        </div>
                    ))}
                    {/* Duplicate set for seamless loop */}
                    {repeatedTypes.map((type, index) => (
                        <div 
                            key={`second-${index}`} 
                            className='type w-[100px] h-[100px] flex justify-center items-center'
                        >
                            <img 
                                src={type} 
                                alt="type" 
                                className='w-full h-full object-contain'
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TypesFood